import { render, staticRenderFns } from "./TicketHandle.vue?vue&type=template&id=0775c9dc&"
import script from "./TicketHandle.vue?vue&type=script&lang=js&"
export * from "./TicketHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports